import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "flexibleDateMinPrice/fetch";
    ActionTypes["fetchSuccess"] = "flexibleDateMinPrice/fetchSuccess";
    ActionTypes["fetchError"] = "flexibleDateMinPrice/fetchError";
    ActionTypes["reset"] = "flexibleDateMinPrice/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (data) => ({
        payload: data
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: error
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
